import { defineStore } from 'pinia'
import type { CurrentQuote } from '~/types'
import nuxtStorage from 'nuxt-storage';

export const useCurrentQuoteStore = defineStore('current-quote', {

  state: () => ({
    currentQuote: {} as CurrentQuote
  }),
  persist: true,
  actions: {
    setCurrentQuoteValue (value: CurrentQuote) {
      this.currentQuote = value
    },
    setSelecteedFrequency(selectedFrequency: string) {
      this.currentQuote.selectedFrequency = selectedFrequency
    },
    reset() {
      this.currentQuote = {} as CurrentQuote
      nuxtStorage?.sessionStorage?.removeItem('current-quote');
    },
  },
  getters: {
    selectedFrequency: state => state.currentQuote.selectedFrequency,
    coverage: state => state.currentQuote.coverage,
    premiums: state => state.currentQuote.premiums,
  }
})
